import { memo } from 'react';
import { Position } from 'react-flow-renderer';
import { Condi } from '../../ModelElements/ConditionalNode/styles';

import { ConditionalStyle, HandleStyle } from './styles';

const ConditionalStart = ({
  data,
  id,
  targetPosition = Position.Left,
  sourcePosition = Position.Right,
}) => {
  const status = data.status;

  return (
    <Condi
      style={{
        cursor: status === 'doing' ? 'pointer' : 'auto',
      }}
    >
      <ConditionalStyle
        className="flow_elements_node"
        data-id={id}
        status={data.status}
      >
        <HandleStyle
          type="target"
          id="c"
          style={{ top: '0' }}
          position={targetPosition}
        />
        <HandleStyle
          type="source"
          position={sourcePosition}
          style={{ top: '100%' }}
          id="a"
        />
      </ConditionalStyle>
      <div style={{ margin: '10px' }}>{data.label.toUpperCase()}</div>
    </Condi>
  );
};

export default memo(ConditionalStart);
